import { Accordion, AlertContainer, Button, PageTitle } from '@/components';
import { useModal } from '@/hooks';
import { useDeleteQuestion, useUpdateQuestion } from '@/services';
import { useGetQuestions } from '@/services/queries/questions';
import { CircleFadingPlus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { FaqForm } from './FaqForm';

const Faq = () => {
	const navigate = useNavigate();
	const {
		setConfirmText,
		setCancelText,
		openModal,
		setOnConfirm,
		closeModal,
	} = useModal();
	const { data: questionsData } = useGetQuestions();
	const { mutate: deleteMutation } = useDeleteQuestion();
	const { mutate: updateMutation } = useUpdateQuestion(closeModal);

	const handleOnDelete = (question: Questions.Question) => {
		setConfirmText('confirmar');
		setCancelText('Cancelar');

		const message = (
			<p className="text-base text-dark">
				Tem certeza que deseja deletar a faq{' '}
				<span className="font-semibold text-red-500">
					"{question.question}"
				</span>
			</p>
		);

		openModal({
			content: <AlertContainer message={message} />,
		});

		setOnConfirm(() => deleteMutation(question.id));
	};

	const handleEdit = (question: Questions.Question) => {
		const onUpdate = (body: Questions.Create) => {
			updateMutation({ id: question.id, body });
		};

		openModal({
			content: (
				<FaqForm
					onBack={closeModal}
					defaultValues={question}
					onSubmit={onUpdate}
					submitButtonText="Salvar alterações"
				/>
			),
			title: <h3 className="text-dark">Editar faq</h3>,
		});
	};

	return (
		<section className="animate-fade-in space-y-6 overflow-hidden px-4 py-6">
			<div className="flex items-center justify-between">
				<div className="space-y-1">
					<PageTitle text="Faq" />
					<p className="text-sm text-stone-400">
						Perguntas frequentes.
					</p>
				</div>
				<Button
					className="rounded-full bg-black px-6 py-2.5 font-bold shadow-md hover:bg-neutral-800"
					startIcon={<CircleFadingPlus className="w-4 text-light" />}
					text="Nova faq"
					onClick={() => navigate('criar')}
				/>
			</div>
			<div>
				{questionsData && (
					<Accordion
						className="!mx-0 gap-1"
						questions={questionsData}
						itemsPerPage={7}
						showHandles={true}
						onEdit={handleEdit}
						onDelete={handleOnDelete}
					/>
				)}
			</div>
		</section>
	);
};

export { Faq };
